import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import './Header.css';

const Header = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Detect current path to set background
  const isHome = location.pathname === '/';

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  const getActiveClass = ({ isActive }) => (isActive ? 'active-link' : 'inactive-link');

  return (
    <AppBar
      position="relative"
      sx={{
        backgroundColor: isHome ? 'transparent' : '#000',
        boxShadow: 'none',
        zIndex: 10,
        transition: 'background-color 0.3s ease',
      }}
    >
      <Toolbar>
        {/* Clickable logo */}
        <img
          src={logo}
          alt="Logo"
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
          className={isMobile ? 'header-logo-mobile' : 'header-logo'}
        />

        <div className="nav-links">
          {!isMobile && (
            <>
              <NavLink to="/" className={getActiveClass}>
                <Button color="inherit">Home</Button>
              </NavLink>
              <NavLink to="/products" className={getActiveClass}>
                <Button color="inherit">Products</Button>
              </NavLink>
              <NavLink to="/contact" className={getActiveClass}>
                <Button color="inherit">Contact Us</Button>
              </NavLink>
            </>
          )}

          {isMobile && (
            <IconButton edge="end" color="inherit" onClick={toggleMenu}>
              <MenuIcon />
            </IconButton>
          )}
        </div>

        <Drawer anchor="top" open={openMenu} onClose={toggleMenu}>
          <List className="drawer-list">
            <IconButton className="close-btn" onClick={toggleMenu}>
              <CloseIcon />
            </IconButton>

            <ListItem button onClick={toggleMenu}>
              <NavLink to="/" className={getActiveClass}>
                <ListItemText primary="Home" />
              </NavLink>
            </ListItem>
            <ListItem button onClick={toggleMenu}>
              <NavLink to="/products" className={getActiveClass}>
                <ListItemText primary="Products" />
              </NavLink>
            </ListItem>
            <ListItem button onClick={toggleMenu}>
              <NavLink to="/contact" className={getActiveClass}>
                <ListItemText primary="Contact Us" />
              </NavLink>
            </ListItem>
          </List>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
